<form #form="ngForm" novalidate>
    <div class="row container-form-list mb-3">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                    <h6 class="card-title">Participantes da Central de Compras</h6>
                </div>
                <div class="table-responsive">
                    <table class="table table-striped table-hover table-bordered">
                        <thead>
                            <tr>
                                <th class="col-delete" title="Remover Participante" *ngIf="canEdit"></th>
                                <th class="col-participante">Participante</th>
                                <th class="col-perc-participacao text-right">Participação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let entity of entities; let i = index">
                                <td class="col-delete" *ngIf="canEdit">
                                    <a class="btn btn-link" (click)="delete(entity, i)">
                                        <i class="far fa-trash-alt" aria-hidden="true"></i>
                                    </a>
                                </td>
                                <td class="col-participante">
                                    <sgt-typeahead-cliente 
                                        [(ngModel)]="entity.clientePariticipante" name="clienteCentralComparParticipante_{{i}}" id="clienteCentralComparParticipante_{{i}}"
                                        #typeaheadParticipante #clienteCentralCompraParticipante="ngModel" [ngControl]="clienteCentralCompraParticipante" required="required"
                                        [somenteParticipaveisCentalDeCompra]="true"
                                        [idsIgnore]="getIdsParticipantesIgnore()"
                                        [dropup]="i > 3"
                                        (entitySelected)="onSelectParticipante(entity, i)"
                                        (clearEntity)="clearParticipante(entity)"
                                        [disabled]="!canEdit"
                                        [readonly]="!canEdit">
                                    </sgt-typeahead-cliente>
                                    <sgt-form-control-error
                                        *ngIf="clienteCentralCompraParticipante.errors && clienteCentralCompraParticipante.errors.required && clienteCentralCompraParticipante.dirty"
                                        msgError="O participante é obrigatório">
                                    </sgt-form-control-error>                                    
                                </td>                            
                                <td class="col-perc-participacao text-right">
                                    <div class="input-group">
                                        <sgt-decimal2 [(ngModel)]="entity.percParticipacaoCentralCompra" name="clienteCentralCompraParticipantePercParticipacao_{{i}}" id="clienteCentralCompraParticipantePercParticipacao_{{i}}"
                                            #percParticipacaoCentralCompra="ngModel"  [ngControl]="percParticipacaoCentralCompra" [digits]="0"
                                            (ngModelChange)="onChangePerParticipacao()"
                                            #inputPercParticipacao
                                            [disabled]="!canEdit"
                                            [readonly]="!canEdit">
                                        </sgt-decimal2>
                                        <div class="input-group-append">
                                            <span class="input-group-text">%</span>
                                        </div>                                
                                    </div>                                            
                                </td> 
                            </tr>
                            <tr *ngIf="entities?.length === 0" class="no-record">
                                <td class="text-center" colspan="3">
                                    <i class='fas fa-info' aria-hidden='true'></i> Nenhum participante adicionado
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td class="col-delete" *ngIf="canEdit"></td>
                                <td class="col-participante"></td>
                                <td class="col-perc-participacao text-right">
                                    {{(percParticipacaoTotalCentralCompra ? percParticipacaoTotalCentralCompra : 0) | decimalFormat: 1:0:0}}%
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="card-footer" *ngIf="canEdit">
                    <button type="button" class="btn btn-primary btn-sm" (click)="insert()">
                        <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Participante
                    </button>
                </div>
            </div>
        </div>
    </div>    
</form>